import React, { useState, useEffect } from 'react'
import Grid from '../layout/grid'

export default props => {

	const [pesquisar, setPesquisar] = useState(props.value || '');

	useEffect(() => {
		setPesquisar(props.value || '');
	}, [props.value]);

	const aplicarPesquisa = valor => {
		if (props.onChange) {
			props.onChange(valor);
		}
	};

	return (
		<Grid
			cols={props.cols}
			style={{
				maxWidth: props.maxWidth,
				minWidth: props.minWidth,
				marginRight: props.marginRight
			}}
		>
			<div
				className='form-group'
				style={{ marginBottom: props.marginBottom }}
			>
				{props.label &&
					<label htmlFor='pesquisa_geral'>
						{props.label}
					</label>
				}

				<div className='input-group' id='pesquisar'>

					<input
						type='text'
						name='pesquisa_geral'
						className='form-control datetimepicker-input'
						data-target='#pesquisar'
						placeholder='Adicione + para combinar pesquisas'
						value={pesquisar}

						onChange={e => {

							const valor = e.target.value;

							setPesquisar(valor);

							// Se limpar o campo, já aplica
							if (!valor) {
								aplicarPesquisa('');
							}
						}}

						onBlur={() => {
							aplicarPesquisa(pesquisar);
						}}

						onKeyDown={e => {
							if (e.key === 'Enter') {
								aplicarPesquisa(pesquisar);
							}
						}}
					/>

					<div
						type='button'
						className='input-group-append'
						data-target='#pesquisar'
					>
						<div
							className='input-group-text'
							onClick={() => {
								aplicarPesquisa(pesquisar);
							}}
						>
							<i className='fas fa-search'></i>
						</div>
					</div>

				</div>
			</div>
		</Grid>
	);
}